if (!customElements.get('policy-assistant')) {
  class PolicyAssistant extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-policy-assistant-form]');
      this.input = this.querySelector('[data-policy-assistant-input]');
      this.result = this.querySelector('[data-policy-assistant-result]');
      this.resultLabel = this.querySelector('[data-policy-assistant-result-label]');
      this.resultQuestion = this.querySelector('[data-policy-assistant-result-question]');
      this.resultAnswer = this.querySelector('[data-policy-assistant-result-answer]');
      this.resultLink = this.querySelector('[data-policy-assistant-result-link]');
      this.dataNode = this.querySelector('[data-policy-assistant-data]');

      if (!this.form || !this.input || !this.result || !this.dataNode) return;

      try {
        this.entries = JSON.parse(this.dataNode.textContent).filter(
          (entry) => entry.question && entry.answer,
        );
      } catch (error) {
        this.entries = [];
      }

      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    }

    normalize(value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9$]+/g, ' ')
        .trim();
    }

    expandQuery(value) {
      let query = ` ${this.normalize(value)} `;
      const intents = [
        [/\b(arrive|arrival|delivery|deliver|shipping|ship|transit|how long)\b/g, ' shipping delivery transit time processing arrive '],
        [/\b(return|send back|exchange)\b/g, ' return returns exchange authorization '],
        [/\b(refund|refunded|refunds|refunding|money back|money|reimburse|reimbursed)\b/g, ' refund reimbursement money back payment method approval '],
        [/\b(address.*return|return.*address|where.*send.*return)\b/g, ' return address warehouse return instructions authorization '],
        [/\b(cancel|change|modify|wrong address)\b/g, ' change cancel order address edit '],
        [/\b(pay|payment|card|visa|mastercard|paypal|apple pay|google pay|shop pay)\b/g, ' payment card checkout wallet declined '],
        [/\b(size|sizing|fit|measurements)\b/g, ' size sizing fit measurements product page '],
        [/\b(material|fabric|composition|care)\b/g, ' material fabric composition care product details '],
        [/\b(contact|support|email|phone|help|hours|open)\b/g, ' contact support email phone hours mountain time '],
        [/\b(damaged|defective|wrong item|incorrect item)\b/g, ' damaged defective incorrect wrong item issue '],
        [/\b(cost|price|free|3 99|3.99)\b/g, ' cost price free 3.99 shipping '],
      ];

      for (const [pattern, expansion] of intents) {
        if (pattern.test(query)) query += expansion;
      }

      return this.normalize(query);
    }

    scoreEntry(entry, query) {
      const tokens = [...new Set(query.split(' ').filter((token) => token.length > 2))];
      const question = this.normalize(entry.question);
      const keywords = this.normalize(entry.keywords);
      const answer = this.normalize(entry.answer);
      let score = 0;

      for (const token of tokens) {
        if (keywords.includes(token)) score += 4;
        if (question.includes(token)) score += 3;
        if (answer.includes(token)) score += 1;
      }

      const phrases = String(entry.keywords || '')
        .split(',')
        .map((phrase) => this.normalize(phrase))
        .filter((phrase) => phrase.length > 3);
      for (const phrase of phrases) {
        if (query.includes(phrase)) score += 8;
      }

      return score;
    }

    handleSubmit(event) {
      event.preventDefault();
      const query = this.expandQuery(this.input.value);
      if (!query) return;

      const ranked = this.entries
        .map((entry) => ({ entry, score: this.scoreEntry(entry, query) }))
        .sort((a, b) => b.score - a.score);
      const match = ranked[0];

      if (!match || match.score < 4) {
        this.showFallback();
        return;
      }

      this.resultLabel.textContent = 'Answer based on our store information';
      this.resultQuestion.textContent = match.entry.question;
      this.resultAnswer.textContent = match.entry.answer;
      this.updateLink(match.entry.url, match.entry.linkText);
      this.result.hidden = false;
    }

    showFallback() {
      this.resultLabel.textContent = 'More help needed';
      this.resultQuestion.textContent = 'We could not find a confident answer.';
      this.resultAnswer.textContent =
        'Try asking about shipping, returns, refunds, payments, order changes, sizing, or customer support. You can also contact us for help with your specific order.';
      this.updateLink('/pages/contact', 'Contact customer support');
      this.result.hidden = false;
    }

    updateLink(url, label) {
      if (url && label) {
        this.resultLink.href = url;
        this.resultLink.textContent = label;
        this.resultLink.hidden = false;
      } else {
        this.resultLink.hidden = true;
        this.resultLink.removeAttribute('href');
        this.resultLink.textContent = '';
      }
    }
  }

  customElements.define('policy-assistant', PolicyAssistant);
}
